/*
  Целое число из текстового поля: «значение или причина», а не молчаливый нуль.

  Заведено 28.10.2026 (аудит 26.10.2026, строка 299 реестра). `Number('6х')` даёт
  NaN, `Number('')` - ноль, а в тело запроса NaN уходит как null: опечатка молча
  превращалась в «без ограничения» или в ноль. Здесь опечатка получает слова,
  которые форма ставит под самим полем.

  Проверяется только запись числа (цифры, целое) и, если вызывающий её назвал,
  диапазон, уже стоявший на поле. Собственных правил предметной области кабинет
  не заводит: их по-прежнему даёт сервер (`fieldErrors`).

  Пустое поле - не ошибка: `{ value: null, error: null }`. Обязательность
  поля решает тот, кто его вызывает.
*/

const WHOLE = /^[+-]?\d+$/

export function parseCount(text, { min, max } = {}) {
  const raw = String(text ?? '').trim()
  if (raw === '') return { value: null, error: null }
  if (!WHOLE.test(raw)) return { value: null, error: 'Введите целое число цифрами.' }
  const value = Number(raw)
  // `!= null`: граница, которой нет (undefined или null с сервера), не проверяется.
  const low = min != null
  const high = max != null
  if (low && high && (value < min || value > max)) {
    return { value: null, error: `Число от ${min} до ${max}.` }
  }
  if (low && value < min) return { value: null, error: `Не меньше ${min}.` }
  if (high && value > max) return { value: null, error: `Не больше ${max}.` }
  return { value, error: null }
}
